import { DATIQ_DEFAULT_ARRAY } from '@dat/datiq-core/models';
import {
    DatiqTableRowSchema,
    IDatiqTableRow,
    emptyDatiqTableRow,
} from '../../datiq-table-row';
import { z } from 'zod';

export const DatiqTableSchema = z.object({
    id: z.string(),
    rows: z.array(DatiqTableRowSchema),
    headerRow: DatiqTableRowSchema,
    showAll: z.boolean(),
    pageSize: z.number(),
    loaded: z.boolean().optional(),
    interactive: z.boolean().optional(),
    headerStatic: z.boolean().optional(),
    rowHeight: z.number().optional(),
});

export interface IDatiqTable extends z.infer<typeof DatiqTableSchema> {}

export const DatiqTablePageSchema = z.object({
    index: z.number(),
    size: z.number(),
    elements: z.number(),
});

export interface IDatiqTablePage extends z.infer<typeof DatiqTablePageSchema> {}
export const emptyDatiqTablePage: IDatiqTablePage = {
    index: 0,
    size: 0,
    elements: 0,
};

export const emptyDatiqTable: IDatiqTable = {
    id: '',
    rows: DATIQ_DEFAULT_ARRAY as IDatiqTableRow[],
    headerRow: emptyDatiqTableRow,
    showAll: false,
    pageSize: 0,
    interactive: false
};
